module.exports = __webpack_public_path__ + "static/media/bg3.19e7349d.png";